module.exports = __webpack_public_path__ + "static/media/nft.7fbfb3ca.png";